import ReactDom from 'react-dom';
import './LoadingPopup.css';

export default function LoadingPopup() {
    return ReactDom.createPortal(
        <div className="modalOverlay">
            <div className="modalPopup LoadingPopup">
                <div>
                    <img src="./loading-bar.gif" alt="loading"/>
                </div>
                <div className="message">
                    Loading...
                </div>
            </div>
        </div>,
        document.getElementById('modalRoot')
    );
}